const es = {
  hero: {
    workedFor: "trabajé para",
    role: "Ingeniero de Software",
    bio: "me encanta construir cosas que hagan la vida más fácil.",
    bio2: "la mayoría de mis proyectos empezaron como soluciones a problemas cotidianos y terminaron siendo apps útiles para otros.",
    bio3: "creo que todos tenemos un propósito; el mío es usar lo que sé para construir y empujar a la humanidad hacia adelante, con soluciones que ayuden a la sociedad a llegar a las estrellas ✨.",
    graduated: "Graduado",
    degree: "Ingeniería en Sistemas · UTN, Argentina",
    experience: "Experiencia",
    experienceLine: "7+ años llevando software a producción",
    alwaysLearning: "Siempre aprendiendo",
    learningLine: "8+ certificaciones y cursos",
    contactMe: "Contactame",
  },
  sections: {
    techStack: "Stack Tecnológico",
    experience: "Experiencia",
    sideProjects: "Proyectos Personales",
    sideProjectsSub: "Cosas que hice fuera del laburo — por curiosidad, para aprender o resolver mis propios problemas.",
  },
  experience: {
    problem: "Problema",
    solution: "Solución",
    impact: "Impacto",
    present: "Actualidad",
  },
  footer: {
    tagline: "Ingeniero de Software",
  },
};

export default es;
